export const ParkingLotControlType = Object.freeze({
	Unit: 0,
	Total: 1,
	UnitAndTotal: 2,
});

export const ParkingLotControlTypeText = Object.freeze({
	[ParkingLotControlType.Unit]: "Vagas por Unidade",
	[ParkingLotControlType.Total]: "Vagas Totais",
	[ParkingLotControlType.UnitAndTotal]: "Vagas por Unidades e Totais",
});